export const reportsFormatter = (reports) => reports.map((r) => ({
  ...r,
  metadata: JSON.parse(r.metadata),
}));

export default reportsFormatter;
